export default __webpack_public_path__ + "media/game-action.d1b9ca3e.png";